import Typography from '@/common/components/base/typography/Typography';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import { getDamagedAdjusterAttachedImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterAttachedImages/getDamagedAdjusterAttachedImagesQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';
import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import { css } from 'styled-system/css';
import { FileRoleTypeProps } from '@/common/types/ApiResponseTypes.type';
import { ImagesListName } from '@/common/utils/ImagesListName';

const ShowAdjusterAttachedImages = ({ userType }: FileRoleTypeProps) => {
  const { id, damagedId } = useParams();

  const { data: imagesData } = useQuery(
    getDamagedAdjusterAttachedImagesQueryOptions({
      id: Number(id),
      damaged_id: Number(damagedId),
      type: 'vehicle',
      fileType: userType,
    }),
  );
  if (!imagesData?.damaged_parts?.length && !imagesData?.vehicle?.length) {
    return (
      <Box mt="100px">
        <EmptyImagesListIcon className={css({ mx: 'auto' })} />
      </Box>
    );
  }
  return (
    <>
      <Typography textStyle="b1" color="purple-1" my="24px">
        تصاویر دور تا دور وسیله‌نقلیه
      </Typography>
      <Flex
        gap="1rem"
        maxWidth="maxContainer"
        margin="auto"
        mt="1.5rem"
        className={grid({ columns: 2 })}
      >
        {imagesData?.vehicle?.map((vehicleImages, index) => {
          return (
            <ImageCard
              key={vehicleImages.id}
              imageData={{
                name: ImagesListName({
                  titleType: 'attachment',
                  index,
                }),
                src: vehicleImages.image,
              }}
            />
          );
        })}
      </Flex>
      {imagesData?.damaged_parts?.length ? (
        <>
          <Typography textStyle="b1" color="purple-1" my="24px">
            تصاویر نقاط آسیب‌دیده
          </Typography>
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {imagesData?.damaged_parts?.map((vehicleImages) => {
              return (
                <ImageCard
                  key={vehicleImages.id}
                  imageData={{
                    name: vehicleImages.title?.fa_const,
                    src: vehicleImages.image,
                  }}
                />
              );
            })}
          </Flex>
        </>
      ) : (
        <>
          <Typography textStyle="b1" color="purple-1" my="24px">
            تصاویر نقاط آسیب‌دیده
          </Typography>
          <Box mt="100px">
            <EmptyImagesListIcon className={css({ mx: 'auto' })} />
          </Box>
        </>
      )}
    </>
  );
};

export default ShowAdjusterAttachedImages;
